export enum NFT_STANDARDS {
  EXT = "EXT",
}
